import React from 'react';

const PaginationFirst = (props) => (
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
  <path d="M9 0.808609L9 11.1914C9 11.9104 8.13076 12.2704 7.6224 11.762L2.431 6.57063C2.11587 6.2555 2.11587 5.74452 2.431 5.42939L7.6224 0.237991C8.13076 -0.270408 9 0.0896683 9 0.808609Z" fill={props.color ? props.color : 'white'}/>
  <rect x="2.25" y="12" width="2.25" height="12" rx="0.5" transform="rotate(180 2.25 12)" fill={props.color ? props.color : 'white'}/>
  </g>
  </svg>
);

export default PaginationFirst;
